/*
 * Copyright (C) 2024 - Potentially Ltd
 *
 * Please see distribution for license.
 */

import { MemberReview, ReviewItemType } from '../../../shared/models';
import { ReviewItem } from '../models';

export class SetReviewItem {
  static readonly type = '[Reviews] Set review item';

  constructor(public reviewItem: ReviewItem) {}
}

export class SetSurroundingUserReviews {
  static readonly type = '[Reviews] Set surrounding user reviews';

  constructor(public membersReviews: MemberReview[]) {}
}

export class LoadReviewDetails {
  static readonly type = '[Reviews editor] Load Review Details';

  constructor(
    public reviewItemUri: string,
    public learnerUserUid: string,
  ) {}
}

export class LoadReviewCardsOnly {
  static readonly type = '[Mentor Review] Load Review Cards only';

  constructor(
    public itemType: ReviewItemType,
    public userUid: string,
    public itemUid: string,
  ) {}
}

export class LoadMentorFeedback {
  static readonly type = '[Mentor Review] Load mentor feedback';

  constructor(
    public playlistUid: string,
    public learnerUserUid: string,
    public mentorUserUid: string,
  ) {}
}

export class ClearReviewsState {
  static readonly type = '[Reviews] Clear reviews state';

  constructor(public clearSurroundingUserReviews: boolean = true) {}
}
